
import {SocialMedia} from './socialMedia';
import {EmailImage} from '../email/emailImage';
import {TSMap} from 'typescript-map';
import {JsonObject, JsonProperty} from 'json2typescript';
import {TSStringToStringMapConverter} from '../../customJsonConverters/TSStringToStringMapConverter';
import {ExternalLinkConverter} from '../../customJsonConverters/ExternalLinkConverter';
import {ExternalLink} from './externalLink';
import {EmailImageConverter} from '../../customJsonConverters/EmailImageConverter';

@JsonObject('Facebook')
export class Facebook extends SocialMedia {

   // TODO: To be removed once inheritance concept in json2Typescript is cleared

   /*@JsonProperty('shareClass')
   public shareClass = '';

   @JsonProperty('clickArea')
   public clickArea = '';

   @JsonProperty('configFile')
   public configFile = '';

   @JsonProperty('link',ExternalLinkConverter)
   public hyperLinks= new ExternalLink();

   @JsonProperty('image')
   public image = '';*/
   ////////





   @JsonProperty('facebook_app_id')
   facebook_app_id = '';

   @JsonProperty('shareImage')
   shareImage = '';

   @JsonProperty('socialQuestion',EmailImageConverter)
   socialQuestion = new EmailImage();

   @JsonProperty('custom_url')
   custom_url = '';

   @JsonProperty('log_out')
   log_out:false;

   @JsonProperty('hashMessage',TSStringToStringMapConverter)
   hashMessage:TSMap<string,string> = new TSMap();// {[key:string]: string;} ={};
   // baseSocial:BaseSocial;

   constructor() {
     super();
     // this.baseSocial = base;
   }






}
